export default function Hero() {
  return (
    <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/29be8430f7dc7131054e4c45b0db4208.jpg"
          alt="목형 제작 전문"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>
      <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">목형(목금형) 제작</h1>
        <p className="text-xl md:text-2xl mb-8 leading-relaxed">
          30년 전통의 숙련된 기술로 완성하는<br />
          특수목형 제작 전문 기업
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="tel:02-2263-8248"
            className="inline-flex items-center justify-center gap-2 bg-[#D4AF37] hover:bg-[#C19B2B] text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-xl"></i>
            02-2263-8248
          </a>
          <a
            href="/quote"
            className="inline-flex items-center justify-center gap-2 bg-white hover:bg-gray-100 text-[#1e3a8a] px-8 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-text-line text-xl"></i>
            견적 문의
          </a>
        </div>
      </div>
    </section>
  );
}
